module.exports = __webpack_public_path__ + "img/qijian-dingbu.c6e575e4.svg";